<template>
  <div class="footer-wrap">
    <div class="footer-container">
      <sitemap></sitemap>
      <footer>
        <div class="co-social-wrap">
          <div class="co-wrap">
            <div>
              {{ $t('main.CO_IND2') }} | {{ $t('main.CO_IND3') }} | {{ $t('main.CO_COMM1') }} |
              {{ $t('main.CO_SHOP2') }}
            </div>
            <div>{{ $t('main.CO_459') }}</div>
          </div>
          <div id="social">
            <a class="facebook_btn" href="https://fb.com/midlandici459" target="_blank"
              ><img src="/ics/property/img/facebook.svg"
            /></a>
            <a class="youtube_btn" href="https://youtube.com/midlandici" target="_blank"
              ><img src="/ics/property/img/youtube.svg"
            /></a>
            <a class="ig_btn" href="https://www.instagram.com/midlandici" target="_blank"
              ><img src="/ics/property/img/instagram.svg"
            /></a>
            <a class="weibo_btn" href="https://weibo.com/midlandici" target="_blank"
              ><img src="/ics/property/img/weibo.svg"
            /></a>
          </div>
        </div>
        <div class="disclaimer">
          上述樓面面積(標示「*」者除外)未經核實，請閱覽<a href="http://459.hk/d" target="_blank"
            >免責聲明</a
          >。藉著閱覽本網頁內所載的資料及素材，閣下已無條件同意免責聲明的條款及條件。<br />
          The above floor area information (save and except those marked with「*」) has not been
          verified. Please read the <a href="http://459.hk/d" target="_blank">Disclaimer</a>. By
          viewing the information and materials contained in this document, you unconditionally
          agree to the terms and conditions of the said disclaimer.
        </div>
        <div>
          <a href="/ics/property/disclaimer" target="_blank">{{ $t('main.DISCLAIMER') }}</a> |
          <a href="/ics/property/infocollection" target="_blank">{{ $t('main.PRIVACY_POLICY') }}</a>

          <br />
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import Sitemap from '@/components/Home/Sitemap';
export default {
  components: {
    Sitemap,
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.footer-wrap {
  background-color: #e5e5e5;
  padding: 0 16px;
}
.footer-container {
  margin: auto;
}

footer {
  max-width: 1360px;
  background-color: #e5e5e5;
  margin: auto;
  color: #2d2d2d;
  text-align: left;
  font-size: 12px;
  padding: 16px 0 64px;
}
.disclaimer {
  font-size: 12px;
  /* text-align: center; */
  margin: 0;
  /* color: #000000; */
  margin: 30px 0 16px;
}
.disclaimer a {
  color: #2d2d2d;
}

#social a span {
  width: 34px;
  height: 34px;
  display: inline-block;
  margin: 0 3px;
}

#social > a > img {
  width: 48px;
  height: 48px;
}

.co-social-wrap {
  display: flex;
  justify-content: space-between;
  gap: 48px;
}

.co-wrap {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

#social {
  display: flex;
  gap: 16px;
  padding: 0;
}

footer a {
  color: #2d2d2d;
}

/* laptop + desktop */
@media (min-width: 992px) {
  footer {
    border-top: 1px solid #2d2d2d;
  }
}
/* desktop 2 */
@media (min-width: 1440px) {
  .footer-container {
    max-width: 1360px;
  }
}

/* desktop 1 */
@media (min-width: 1200px) and (max-width: 1439px) {
  .footer-container {
    max-width: 1138px;
  }
}

/* laptop */
@media (min-width: 992px) and (max-width: 1199px) {
  .footer-container {
    max-width: 938px;
  }
}

/* mobile */
@media (max-width: 991px) {
  #social {
    display: none;
  }
}
</style>
